import PageHeader from "../components/PageHeader";
import CTABanner from "../components/CTABanner";
import { PRODUCT_CATEGORIES } from "../lib/content";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Products() {
  return (
    <div data-testid="products-page">
      <PageHeader
        eyebrow="Products"
        title="What we trade."
        subtitle="Petrochemicals, agricultural commodities, industrial equipment and vehicles — sourced, shipped and delivered worldwide."
        image="https://images.unsplash.com/photo-1565792508000-8aca4a9be4c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
        testId="products-page-header"
      />

      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 space-y-20">
          {PRODUCT_CATEGORIES.map((cat, i) => (
            <motion.article
              key={cat.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6 }}
              className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center"
              data-testid={`product-category-${cat.id}`}
            >
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative aspect-[4/3] overflow-hidden bg-[#0A1F3F]">
                  <img src={cat.image} alt={cat.title} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1 lg:col-start-2" : "lg:col-start-8"}`}>
                <div className="text-eyebrow text-[#F37021] mb-4">
                  {String(i + 1).padStart(2, "0")} — Category
                </div>
                <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.02] text-[#0A1F3F]">
                  {cat.title}
                </h2>
                <p className="mt-5 text-base text-[#4B5668] leading-relaxed">
                  {cat.description}
                </p>
                <ul className="mt-7 flex flex-wrap gap-2">
                  {cat.items.map((it) => (
                    <li
                      key={it}
                      className="text-xs uppercase tracking-[0.15em] font-semibold px-4 py-2 border border-[#0A1F3F] text-[#0A1F3F]"
                    >
                      {it}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/quote?product=${encodeURIComponent(cat.title)}`}
                  data-testid={`product-quote-${cat.id}`}
                  className="mt-10 inline-flex items-center gap-3 bg-[#F37021] hover:bg-[#D35F16] text-white px-8 py-5 text-xs uppercase tracking-[0.2em] font-semibold transition-colors"
                >
                  Request Quote
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
